import { render, staticRenderFns } from "./volunteers-table.vue?vue&type=template&id=354e0c0e&"
import script from "./volunteers-table.vue?vue&type=script&lang=js&"
export * from "./volunteers-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports